// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Lyk5h","version":"Footer_version__zpew8","logos":"Footer_logos__Afmae","link":"Footer_link__evlmu","logo":"Footer_logo__TZpft"};